import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchPresignContrato = async (numeroEmpleado, token) => {
  const method = "POST";
  const headers = { Authorization: `Bearer ${token}` };

  const res = await ApiRequestInterceptor(
    USERS.presignContrato(numeroEmpleado),
    method,
    null,
    headers
  );

  console.log("presignContrato res:", res); // <-- agrega esto

  const status = res.status ?? res.code;
  if (status >= 200 && status < 300) return res.data;

  throw new Error(res?.data?.error || "No se pudo generar URL firmada");
};